export default "__VITE_ASSET__BTNAw56g__"